import { OauthLoginProvider } from 'multirpc-sdk';
import { useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectAssociatedAccounts,
  selectAssociatedAccountsLoading,
  selectAssociatedAccountsState,
  useFetchAssociatedAccountsQuery,
  useLazyFetchAssociatedAccountsQuery,
} from '../actions/fetchAssociatedAccounts';

export interface IUseAssociatedAccounts extends IUseQueryProps {}

export const useAssociatedAccounts = ({
  skipFetching,
}: IUseAssociatedAccounts = {}) => {
  useFetchAssociatedAccountsQuery(
    getQueryParams({ params: undefined, skipFetching }),
  );

  const [handleFetchAssociatedAccounts] = useLazyFetchAssociatedAccountsQuery();

  const associatedAccounts = useAppSelector(selectAssociatedAccounts);

  const loading = useAppSelector(selectAssociatedAccountsLoading);

  const state = useAppSelector(selectAssociatedAccountsState);

  const {
    hasEmailProviderConnected,
    hasGithubProviderConnected,
    hasGoogleProviderConnected,
  } = useMemo(
    () => ({
      hasGoogleProviderConnected:
        associatedAccounts.length > 0 &&
        !!associatedAccounts.find(
          account => account.provider === OauthLoginProvider.Google,
        ),
      hasGithubProviderConnected:
        associatedAccounts.length > 0 &&
        !!associatedAccounts.find(
          account => account.provider === OauthLoginProvider.Github,
        ),
      hasEmailProviderConnected:
        associatedAccounts.length > 0 &&
        !!associatedAccounts.find(
          account => account.provider === OauthLoginProvider.Email,
        ),
    }),
    [associatedAccounts],
  );

  return {
    associatedAccounts,
    handleFetchAssociatedAccounts,
    loading,
    state,
    hasGoogleProviderConnected,
    hasGithubProviderConnected,
    hasEmailProviderConnected,
  };
};
